module.exports = __webpack_public_path__ + "img/13.59f03926.jpg";